import { Component } from '@theme/component';

class ProductInformation extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.#detectSticky();

    window.addEventListener('resize', () => {
      const el = this.querySelector('.product-main__information');
      const fitsInViewport = el?.offsetHeight <= (window.innerHeight - 90);
      el?.classList.toggle('product-main__information--static', fitsInViewport);
      // this.#detectSticky();
    });
  }

  #detectSticky() {
    const el = this.querySelector('.product-main__information');
    const fitsInViewport = el?.offsetHeight <= (window.innerHeight - 90);
    el?.classList.toggle('product-main__information--static', fitsInViewport);
  }
}

if (!customElements.get('product-information')) {
  customElements.define('product-information', ProductInformation);
}